
<style lang='scss'>
</style>

<template>
	<section class="padding-10">
		<compFormEdit col="1" :formdata="getBase" ref="form" v-model="formData"></compFormEdit>
		<vButtonGroup class="text-right">
			<vButton theme="primary" @click="submit">{{$t('global.common.update_submit',{defaultValue:'提交'})}}</vButton>
			<vButton theme="error" @click="cancel">{{$t('global.common.operation_cancel',{defaultValue:'取消'})}}</vButton>
		</vButtonGroup>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { HttpSerialNoEdit, HttpSerialNo } from '@/service/boss/allot';

export default {
	components: {
		compFormEdit: () => import("@components/templates/formedit"),
	},
	data() {
		return {
			loading: false,
			formData: {
				orgId: global.SYSID,
				flag: '',
				sellerSku: '',
				serialNo: '',
			},
		};
	},
	computed: {
		...mapState('boss', ['accounts']),

            getAccountList() {
            const arr = []
            this.accounts.forEach(item => {
                if (item.type === 'amazon') {
                arr.push({
                    value: item.flag,
                    label: item.flag
                })
            }
        });
            return arr.sort(function(a,b){
                return a.value.localeCompare(b.value)
            })
        },

		getBase() {
			return [
				{
					label: this.$t("erp.shopname.account",{defaultValue:'店铺账号'}),
					key: 'flag',
					tag: 'vSelect',
					options: this.getAccountList,
					props: {
						filterable: true,
					}
				}, {
					label: 'Seller Sku',
					key: 'sellerSku',
				}, {
					label: this.$t('erp.serialNos.index',{defaultValue:'序列号'}),
					key: 'serialNo',
				},
			]
		},
	},

	methods: {
		cancel() {
			this.$emit('on-close');
		},
		async submit() {
			let valid = await this.$refs['form'].validate();
			if (!valid) return;
			this.loading = true;
			HttpSerialNoEdit(this.formData).then(res => {
				this.cancel();
				this.$emit('on-update');
				this.$VMessage.success(res.message);
				this.loading = false;
			}).catch(err => {
				this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
				this.loading = false;
			});
		}
	},

};
</script>



